import BeetAPI from '@boite-beet/api-client'
import { createApp } from 'vue'
import { createGtag } from 'vue-gtag'

import App from '@/App.vue'
import langRouter from '@/extensions/langRouter'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/styles/app.scss'

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(langRouter, 'fr')
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })

app.use(
  createGtag({
    tagId: import.meta.env.VITE_APP_GTAG_ID,
    bootstrap: false,
    pageTracker: { router },
  }),
)

/* --- GOOGLE RECAPTCHA ---
   import {VueReCaptcha} from "vue-recaptcha-v3";
   app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_KEY })

 */

app.mount('#app')
